import API from '../API/api';

class Cart {
    constructor() {
        this._cartData = {};
        this._checkoutData = {};
    }

    retreiveContents() {
        return API.GET({
            apiPath: '/cart/get/',
            data: '',
            dataType: 'json'
        }).done((response) => {
            this._postcode = response.postcode || '';

            if (response.cart) {
                this._cartData = response.cart;
            }

            if (response.checkout) {
                this._checkoutData = response.checkout;
            }
        }).catch((error) => {
            console.warn('Could not fetch cart: ' + error);
        });
    }

    getCartProducts() {
        return this._cartData.products;
    }

    getTotalsWithoutExpenses() {
        return this._cartData.totalWithoutExpenses || null;
    }

    getCustomerName() {
        return this._checkoutData.addressBilling.billingFirstName;
    }

    getPostcode() {
        return this._postcode;
    }
}

export { Cart };
export default Cart;
